import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    GetFilterForEntitiesWithSoftDelete,
    GetSoftDeletedRecordsByTable,
    HardDeleteRecordsByTableAndIds,
    RestoreRecords,
} from '../../../reduxToolkit/Commons/CommonsApi';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const HardDeleteApp = () => {
    const { t } = useTranslation();
    let dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedModel, setSelectedModel] = useState('');
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [dataDetail, setDataDetail] = useState('');
    const [deleteEmployeesShow, setDeleteEmployeesShow] = useState(false);
    const [restoreShow, setRestoreShow] = useState(false);
    const [selectItemsForDelete, setSelectItemsForDelete] = useState([]);
    const [model, setModel] = useState('');
    const [modified, setModified] = useState(false);
    const [searchElement, setSearchElement] = useState(''); // Search filter value
    const [openModal, setOpenModal] = useState(false);
    const { getFilterForEntitiesWithSoftDelete } = useSelector((state) => state.CommonsSlice);

    // Opens the modal
    const handleOpenModal = (item) => {
        setSelectedEmployee(item);
        setOpenModal(true);
        setDataDetail(item);
    };

    //get record id the selected model changes
    useEffect(() => {
        setModified(true);
    }, [selectedModel]);

    //Function to restore selected items
    const deleteSelectedEmployees = (deleteItem, table) => {
        dispatch(HardDeleteRecordsByTableAndIds({
            body: deleteItem,
            tableName:table
        })).then(({ payload }) => {
            setSelectItemsForDelete([]);
            setIsAllChecked(false);
            if (payload?.data?.success) {
                toast.success(t('has_been_deleted_successfully'));
                setModified(true);
            }
        });
        setRestoreShow(false);
    };
    // Handles the model change event
    const handleChange = (selectedModel) => {
        if (!selectedModel) return;
        setSelectedModel(selectedModel);
        dispatch(GetSoftDeletedRecordsByTable({ option: selectedModel, pagination: { page: 1, size: 10 } }));
    };
    // Closes the modal and clears the selected
    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedEmployee(null);
    };
    //Function to restore selected items
    const restoreSelectedItems = (deleteItem, table) => {
        const body = { list: deleteItem, table };

        dispatch(RestoreRecords(body)).then(
            ({
                payload: {
                    data: { success },
                },
            }) => {
                setSelectItemsForDelete([]);
                setIsAllChecked(false);
                if (success === true) {
                    toast.success(t('has_been_restore_successfully'));
                    setModified(true);
                }
                setRestoreShow(false);
            },
        );
    };
    // Effect to load the filters for entities with soft delete
    useEffect(() => {
        dispatch(GetFilterForEntitiesWithSoftDelete());
    }, [dispatch]);


    const transformedList = getFilterForEntitiesWithSoftDelete;

    return {
        t,
        DEV,
        permission,
        selectedEmployee,
        selectedModel,
        deleteEmployeesShow,
        restoreShow,
        model,
        handleOpenModal,
        handleChange,
        setDeleteEmployeesShow,
        setRestoreShow,
        setModel,
        handleCloseModal,
        transformedList,
        dataDetail,
        openModal,
        restoreSelectedItems,
        deleteSelectedEmployees,
        selectItemsForDelete,
        setSelectItemsForDelete,
        isAllChecked,
        modified,
        setModified,
        searchElement,
        setIsAllChecked
    };
};

export default HardDeleteApp;
